/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { EditorJsonContent, FaceEditorContent, FalconContent } from './ContentInterfaces';

const normalizeContent = (content: FalconContent | FaceEditorContent): EditorJsonContent => {
  if (content.__type !== 'aem-headless') {
    return {
      ...content,
      autoplaySpeed: +(content as FaceEditorContent).autoplaySpeed,
    } as EditorJsonContent;
  }

  return convertHeadlessContentToEditorFormat(content as FalconContent);
};

const convertHeadlessContentToEditorFormat = (content: FalconContent): EditorJsonContent => {
  const { fields } = content;

  const itemsFromGallery: any = (fields?.gallery as any).map((item: any) => {
    const {
      title,
      bodyText,
      cta1_ctaLink1: ctaLinkValue,
      cta1_ctaText1: cta1TextValue,
      cta1_ctaAria1: cta1AriaValue,
      cta1_openIn: openInValue,
      legalText_mediaDisclaimer: mediaDisclaimerValue,
      legalText_wltpKey: wltpKeyValue,
      asset,
    } = item?.fields;

    const {
      assetType,
      alternateDescription,
      imageUrlSmallViewport,
      imageUrlLargeViewport,
      videoUrlSmallViewport,
      videoUrlLargeViewport,
      autoPlay,
      loop,
      videoHasAudio,
      closedCaption,
      audioDescriptionPortrait,
      alternateDescriptionPortrait,
      closedCaptionPortrait,
      audioDescription,
      preserveVideoWidth,
      preserveImageWidth,
    } = asset.fields;

    const items: any = {
      title,
      bodyText,
      asset: {
        assetType,
        ...(assetType === 'image' && {
          imageUrlSmallViewport: {
            assetValue: imageUrlSmallViewport?.path,
          },
          imageUrlLargeViewport: {
            assetValue: imageUrlLargeViewport?.path,
          },
          alternateDescription,
          preserveImageWidth,
        }),
        ...(assetType === 'video' && {
          videoUrlSmallViewport: {
            assetValue: videoUrlSmallViewport?.path,
          },
          videoUrlLargeViewport: {
            assetValue: videoUrlLargeViewport?.path,
          },
          closedCaption,
          autoPlay,
          loop,
          videoHasAudio,
          audioDescriptionPortrait,
          alternateDescriptionPortrait,
          closedCaptionPortrait,
          audioDescription,
          alternateDescription,
          preserveVideoWidth,
        }),
      },
      cta1: {
        openIn: openInValue,
        ctaText1: cta1TextValue,
        ctaLink1: ctaLinkValue,
        ctaAria1: cta1AriaValue,
      },
      legalText: {
        wltpKey: wltpKeyValue,
        mediaDisclaimer: mediaDisclaimerValue,
      },
    };

    return items;
  });

  const contentInEditorJsonFormat: EditorJsonContent = {
    theme: fields?.theme,
    autoplay: fields?.autoplay,
    autoplaySpeed: +fields?.autoplaySpeed,
    mediaHeight: fields?.mediaHeight,
    gallery: itemsFromGallery,
  };

  return contentInEditorJsonFormat;
};

export default normalizeContent;
